import PrimaryButton from "@/components/PrimaryButton";
import { Size } from "@ever-tutor/et-ui";

/**
 * The footer every checklist filter shares, so the menus cannot drift apart.
 * Source order is visual order (remove, then apply) to keep Tab in step
 * with what the eye reads.
 * Input:  onApply -- commit the pending selection.
 *         onClear -- drop the filter.
 *         isApplyDisabled -- the pending selection cannot be applied yet.
 */
const FilterActions = ({
  onApply,
  onClear,
  isApplyDisabled = false,
}: {
  onApply: () => void;
  onClear: () => void;
  isApplyDisabled?: boolean;
}) => (
  <div className="et-filter-actions">
    <button
      type="button"
      onClick={onClear}
      className="et-filter-remove font-mulish font-semibold"
    >
      Remove filter
    </button>
    <PrimaryButton onClick={onApply} size={Size.XS} disabled={isApplyDisabled}>
      Apply
    </PrimaryButton>
  </div>
);

export default FilterActions;
